module.exports = __webpack_public_path__ + "img/MASTER_ENG_VP_Handbook_Web29.ba03ec61.jpg";